module.exports = __webpack_public_path__ + "static/stopklatka-26-774c6b937f1a365ace0d04a14d40ab72.jpg";